module.exports = __webpack_public_path__ + "static/img/about_authority_01_zh.548b8f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_authority_01_zh.png
// module id = LEZQ
// module chunks = 34